var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section -accordion" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "section__container" }, [
        _c("div", { staticClass: "accordion__description" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("p", { staticClass: "accordion__copy" }, [
            _vm._v("Click to open and view products."),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              class: `button accordion__toggle ${
                _vm.allOpen ? "-closedAccordion" : "-tertiary"
              }`,
              attrs: {
                type: "button",
                "aria-label": "Manufacturers list toggle",
                "aria-pressed": `${_vm.allOpen ? "true" : "false"}`,
              },
              on: { click: _vm.openAll },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.allOpen ? "Close" : "Open") +
                  " All"
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "accordion__container" },
          [_vm._t("default")],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", { staticClass: "accordion__title" }, [
      _vm._v("Our "),
      _c("em", [_vm._v("Manufacturers")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }